export enum APP_STATUS {
  IDLE = 'idle',
  LOADING = 'loading',
  FAILED = 'failed',
}
